var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDropoff = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.698,
    height: 10.649,
    viewBox: "0 0 10.698 10.649",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#427dcc",
    d: "M-6994.014 642.65v-.6a4.737 4.737 0 0 1-4.354-4.348h-.632v-.728h.631a4.734 4.734 0 0 1 4.354-4.347V632h.728v.632a4.732 4.732 0 0 1 4.353 4.347h.633v.728h-.633a4.735 4.735 0 0 1-4.353 4.348v.6zm.728-2.4v1.075a4.007 4.007 0 0 0 3.623-3.619h-1.075v-.728h1.075a4.007 4.007 0 0 0-3.623-3.617v1.111h-.728v-1.111a4.006 4.006 0 0 0-3.622 3.617h1.075v.728h-1.075a4.007 4.007 0 0 0 3.622 3.619v-1.075zm-2.184-2.907a1.819 1.819 0 0 1 1.821-1.817 1.818 1.818 0 0 1 1.819 1.817 1.819 1.819 0 0 1-1.819 1.818 1.82 1.82 0 0 1-1.821-1.818z",
    transform: "translate(6998.999 -632)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDropoff, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dropoff.f6fb2a6c.svg";
export { ForwardRef as ReactComponent };